import React from 'react'

// Big "A" (Large) / small "a" (Compact) flanking a sliding toggle — density
// switch between the two layouts, styled like an iOS-ish switch. The thumb
// sits next to whichever letter is currently active.
export default function ViewSwitch({compact, onToggle}) {
    return (
        <div className='iolx-view-switch' onClick={() => onToggle(!compact)}
        title='Switch between the large and the compact layout'>
            <span className='iolx-view-switch-a-large'>A</span>
            <span className={'iolx-view-switch-track' + (compact? ' compact' : '')}>
                <span className='iolx-view-switch-thumb'></span>
            </span>
            <span className='iolx-view-switch-a-small'>a</span>
        </div>
    )
}
